import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export type MessageVariant = 'sent' | 'received';

export const MessageStyled = styled.div<{
  variant: MessageVariant;
  deleted?: boolean;
}>`
  padding: 16px;
  max-width: 380px;
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.bodySmall)};
  width: fit-content;
  white-space: break-spaces;
  text-align: justify;
  overflow-wrap: anywhere;
  line-break: normal;
  font-style: ${(props) => (props.deleted ? 'italic' : 'normal')};
  ${(props) => {
    switch (props.variant) {
      case 'sent':
        return `
          color: ${props.theme.atlas.semantic.color.type.default};
          background: ${props.theme.atlas.semantic.color.surface.variant};
          border: solid 1px ${props.theme.atlas.semantic.color.action.primary.hover};
          border-radius: 12px 12px 0px 12px;
          align-self: flex-end;
          margin-bottom: 10px;
        `;

      case 'received':
        return `
          color: ${props.theme.atlas.semantic.color.type.default};
          background: ${props.theme.atlas.semantic.color.surface.variant};
          border: solid 1px ${props.theme.atlas.semantic.color.outline.default};
          border-radius: 12px 12px 12px 0px;
          align-self: flex-start;
          margin-bottom: 10px;
        `;
    }
  }};
`;
